@import '~style-sheet-helpers/core.less';
@import '../app-brand/entities/entity-layer.module.less';
@import '../constants/screen-width-breakpoints.module.less';
@import (reference) '../constants/spacing.module.less';

// FSUI common styles
.flex-container {
  display: flex;
  width: 100%;

  @media @mobile {
    flex-direction: column;
  }

  .credit-wrapper {
    padding-right: 72px;
  }

  .billing-wrapper {
    position: relative;

    @media @mobile {
      padding-right: 0;
    }
  }
}

.fsui-wrapper {
  gap: 32px;
}

.loader {
  min-height: 400px;
}

.left {
  > section {
    padding: 0;
  }
}

.right {
  section {
    // this prevents stupid jiggle from clicking on inputs because of underlying border changes
    width: 100%;
  }

  input {
    margin: 0;
  }
}

.left,
.right {
  display: flex;
  flex-direction: column;
  width: 50%;

  .spacer {
    margin: 12px 0;
  }
}

.payment-method-header {
  justify-content: space-between;
}
.add-payment-method-link {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: @space-4;
}
.add-payment-method-icon {
  display: flex;
  width: 16px;
}
